import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import Sidebar from '../../components/Sidebar';
import axios from 'axios';
import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteCompetitiveExamBookMaster = () => {
    const authorizedAxios = generateAxiosInstance()
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        bookName: "",
        instituteCompetitiveExamNameMasterId: '',
        publicationMasterId: '',
        subjects: []
    }
    const [formData, setFormData] = useState([])
    const [syllabusData, setSyllabusData] = useState(initialFormState)
    const [syllabusList, setSyllabusList] = useState([])
    const [editId, setEditId] = useState(null)
    const [subjectList, setSubjectList] = useState([]);
    const [competitiveExamNameList, setCompetitiveExamNameList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [examNameSort, setExamNameSort] = useState(null);
    const [subjectSort, setSubjectSort] = useState(null);
    const [publicationNameSort, setPublicationNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteCompetitiveExamNameMasterDetails.examName", "instituteCompetitiveExamBookMasterDetails.instituteSubjectMasterDetails.subjectName", "publicationMasterDetails.publicationName", "bookName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        const apiUrl = `/get-data-for-syllabus-structure-master`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setFormData(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });

        getCompetitiveExamNameList()
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            await getCompetitiveExamBookList();
        };
    
        fetchData();
    }, [syllabusData.instituteCompetitiveExamNameMasterId, syllabusData.subjects, syllabusData.publicationMasterId]);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getCompetitiveExamBookList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setSyllabusList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(syllabusList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(syllabusList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > syllabusList.length) {
            endIndex = syllabusList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(syllabusList.slice(startIndex, endIndex));
    }, [syllabusList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = '/get-institute-competitive-exam-book-master?';
        if (syllabusData.publicationMasterId) {
            apiUrl += `publicationId=${syllabusData.publicationMasterId}&`;
        }
        if (syllabusData.instituteMasterId) {
            apiUrl += `instituteMasterId=${syllabusData.instituteMasterId}&`;
        }

        if (syllabusData.instituteCompetitiveExamNameMasterId) {
            apiUrl += `instituteCompetitiveExamNameMasterId=${syllabusData.instituteCompetitiveExamNameMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getCompetitiveExamBookList = async () => {
        try {
            const response = await authorizedAxiosInstitute.get(getApiUrl());
            setSyllabusList(response.data.data);
        } catch (error) {
            setSyllabusList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const getCompetitiveExamNameList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setCompetitiveExamNameList(response.data.result)
            })
            .catch(error => {
                setCompetitiveExamNameList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSelectExamName = (e, index) => {
        setSyllabusData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                    subjects: []
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                    subjects: []
                }
            }
        });

        const apiUrl = `/get-institute-competitive-exam-names-wise-subject?InstituteCompetitiveExamNameMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result);
            })
            .catch(error => {
                setSubjectList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const SubList = subjectList?.map((sub) => {
        return {
            value: sub.instituteSubjectMasterDetails.id,
            label: sub.instituteSubjectMasterDetails.subjectName
        }
    }) || [];

    const handleChangeSub = (selectedOptions) => {
        const selectedIds = selectedOptions.map((option) => option.value.toString());
        setSyllabusData((prevData) => {
            return {
                ...prevData,
                subjects: selectedIds,
            }
        })
    }

    const handleInputChange = (e, index) => {
        setSyllabusData((prevData) => {
            if (e.target.name === 'syllabusStructureName') {
                // Update the value at the specified index
                const updatedSyllabusStructureName = [...prevData.syllabusStructureName];
                updatedSyllabusStructureName[index] = e.target.value;
                return {
                    ...prevData,
                    syllabusStructureName: updatedSyllabusStructureName,
                }
            } else if (e.target.name === "bookName") {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value.toUpperCase(),
                }
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value,
                }
            }
        })
    }

    //error
    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(syllabusData).every((value) => typeof (value) === "string" ? value !== '' : value.length !== 0) && Array.isArray(syllabusData.subjects) && syllabusData.subjects.length > 0;
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [syllabusData])

    const addSyllabusType = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-competitive-exam-book-master`;
                const response = await authorizedAxiosInstitute.post(apiUrl, syllabusData);
                await getCompetitiveExamBookList();
                setSyllabusData((prevData) => {
                    return {
                        ...prevData,
                        bookName: '',
                    }
                })

                setSaveId(response.data.result.id);
                setExamNameSort(null);
                setSubjectSort(null);
                setPublicationNameSort(null);
                setBookNameSort(null);
                setSearchValue(null);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(syllabusData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteSyllabus = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-competitive-exam-book-master?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, syllabusList.length);
                await getCompetitiveExamBookList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const updateSyllabus = async () => {
        try {
            setLoading(true);
            const apiUrl = `/edit-institute-competitive-exam-book-master?id=${editId}`;
            const response = await authorizedAxiosInstitute.put(apiUrl, syllabusData);
            setEditId(null);
            setSyllabusData((prevData) => {
                return {
                    ...prevData,
                    syllabusStructureName: [''],
                }
            })
            Swal.fire(
                { text: response.data.message }
            );
        } catch (error) {
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            Swal.fire(
                { text: errorMsg }
            );
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setSubjectSort(null);
            setPublicationNameSort(null);
            setBookNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (subjectSort == true || subjectSort == false) {
            setExamNameSort(null);
            setPublicationNameSort(null);
            setBookNameSort(null);
        }
    }, [subjectSort])

    useEffect(() => {
        if (publicationNameSort == true || publicationNameSort == false) {
            setExamNameSort(null);
            setSubjectSort(null);
            setBookNameSort(null);
        }
    }, [publicationNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectSort(null);
            setPublicationNameSort(null);
        }
    }, [bookNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Book Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-book-open"></i> Competitive Exam Book Master </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Name :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSelectExamName} value={syllabusData.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Name </option>
                                                        {
                                                            competitiveExamNameList?.map((grade) => {
                                                                return <option value={grade.id}>{grade.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteCompetitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.instituteCompetitiveExamNameMasterId}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <Select
                                                        value={SubList.filter(option =>
                                                            syllabusData.subjects && syllabusData.subjects.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="subjects"
                                                        options={SubList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeSub}
                                                    />
                                                    {error.subjects && <p style={{ color: 'red' }}>{error.subjects}</p>}
                                                </div>

                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Publication :</label>
                                                    <select class="form-select" aria-label="Default select example" name='publicationMasterId' onChange={handleInputChange} value={syllabusData.publicationMasterId}>
                                                        <option selected value={''} disabled>Select Publication</option>
                                                        {
                                                            formData?.publicationData?.map((publication) => {
                                                                return <option value={publication.id}>{publication.publicationName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.publicationMasterId && <p style={{ color: 'red' }}>{error.publicationMasterId}</p>}
                                                </div>
                                                <div className="col-md-4">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Book Name :</label>
                                                    <input type="text" className="form-control" id={`bookName`} name='bookName' onChange={handleInputChange} value={syllabusData.bookName} />
                                                    {error.bookName && <p style={{ color: 'red' }}>{error.bookName}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId &&
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addSyllabusType}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setSyllabusList([]); setEditId(''); setSyllabusData(initialFormState) }}>Reset</button>
                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateSyllabus} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width ">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Competitive Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scipe="col">
                                                                            Subject
                                                                            <SortIcon sortState={subjectSort} setSortState={setSubjectSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"instituteCompetitiveExamBookMasterDetails.instituteSubjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Publication
                                                                            <SortIcon sortState={publicationNameSort} setSortState={setPublicationNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"publicationMasterDetails.publicationName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setSyllabusList} setCurrPage={setCurrPage} sortingPath={"bookName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData.map((syllabus, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{syllabus.instituteCompetitiveExamNameMasterDetails.examName}</td>
                                                                                        <td>{syllabus.instituteCompetitiveExamBookMasterDetails.map(subject => (subject.instituteSubjectMasterDetails.subjectName)).join(", ")}</td>
                                                                                        <td>{syllabus.publicationMasterDetails?.publicationName}</td>
                                                                                        <td>{syllabus.bookName}</td>
                                                                                        <td>
                                                                                            {/* <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setSyllabusData({
                                                                                                    bookName:syllabus.bookName,
                                                                                                    instituteCompetitiveExamNameMasterId:syllabus.instituteCompetitiveExamNameMasterDetails.id,
                                                                                                    publicationMasterId:syllabus.publicationMasterDetails?.id
                                                                                                });
                                                                                                setEditId(syllabus.id)
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button> */}
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteSyllabus(syllabus.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>

                                                                                <th colspan={"100%"} style={{ textAlign: 'center', padding: "50px" }}>No Syllabus Structure Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={syllabusList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteCompetitiveExamBookMaster;